import * as React from 'react';

function SvgInvestidor(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g className="investidorv2_svg__layer">
        <path
          clipRule="evenodd"
          d="M14.17 19.595l2.17-.002v1.086H.067a6.51 6.51 0 016.509-6.51h4.34a6.48 6.48 0 013.254.872v4.554zM8.746 12a4.34 4.34 0 100-8.68 4.34 4.34 0 000 8.68zm11.933-5.018v-2.17h-2.17v2.17l-.19.006a3.255 3.255 0 00.19 6.504h2.17l.127.007a1.085 1.085 0 01-.127 2.162h-4.34v2.17h2.17v2.17h2.17v-2.17l.192-.005a3.255 3.255 0 00-.192-6.504H18.51l-.127-.007a1.085 1.085 0 01.127-2.163h4.34v-2.17h-2.17z"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
}

export default SvgInvestidor;
